export const HERO_IMAGE = {
  x1: 'https://static.cdn-cian.ru/frontend/e2e-form-assets/promo/images/hero_1x.png',
  x2: 'https://static.cdn-cian.ru/frontend/e2e-form-assets/promo/images/hero_2x.png',
};

export const CONSULTATION_BLOCK = {
  x1: 'https://static.cdn-cian.ru/frontend/e2e-form-assets/promo/images/call_me_x1.png',
  x2: 'https://static.cdn-cian.ru/frontend/e2e-form-assets/promo/images/call_me_x2.png',
};

export const HOW_IT_WORKS_PREVIEW =
  'https://static.cdn-cian.ru/frontend/e2e-form-assets/promo/videos/preview/howItWorksPreview.png';

export const RAISING_HANDS =
  'https://static.cdn-cian.ru/frontend/e2e-form-assets/partner_rewards/other/raising_hands.png';

export const PHONE = 'https://static.cdn-cian.ru/frontend/e2e-form-assets/partner_rewards/icons/phone.svg';

export const TELEGRAM_LOGO = 'https://static.cdn-cian.ru/frontend/e2e-form-assets/partner_rewards/icons/tg.svg';

export const EMAIL = 'https://static.cdn-cian.ru/frontend/e2e-form-assets/partner_rewards/icons/mail.svg';
